export default __webpack_public_path__ + "static/media/warning--fresh-oil--g1.2aa89129.png";